module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_9_3.62474876.jpeg";